import {
  useKivunovaTranslation,
  usePlatformConfig
} from "@kivunova/kivufrontendcommon";
import { translateOrganizationLabels } from "../config/organizationVerbiageConfig";

/**
 * Resolved organization UI labels for the active tenant.
 * API fields remain `companyId` / `company` — this is presentation copy only.
 */
export const useOrganizationLabels = () => {
  const { t } = useKivunovaTranslation();
  const { config } = usePlatformConfig();

  return translateOrganizationLabels(t, config?.businessType);
};

export const getOrganizationLabelsForBusinessType = (
  t: (key: string, fallback: string) => string,
  businessType?: string | null
) => translateOrganizationLabels(t, businessType);
